import * as Models from '../../../models';
import { ChampionshipService, OppositionService } from '../..';
import { OppositionAllowedEmbeddedEntities } from '../../opposition-service';

export interface ParticipantChampionshipStatusWithOpposition extends Models.ParticipantChampionshipStatus {
  opposition: Models.Opposition | undefined;
}

const getParticipantChampionships: () => Promise<ParticipantChampionshipStatusWithOpposition[]> = async () => {
  const participantChampionshipsStatus = await ChampionshipService.getParticipantChampionshipsStatus();
  const championshipWithoutParticipation = participantChampionshipsStatus.resources.filter(
    resource => !resource.isParticipant,
  );
  const championshipWithParticipationCloseToExit = participantChampionshipsStatus.resources.filter(
    resource => resource.isParticipant && resource.isCloseToExitChampionship,
  );

  const oppositionIdsWithoutParticipation = championshipWithoutParticipation.map(({ mainContentId }) => mainContentId);
  const oppositionIdsWithParticipationCloseToExit = championshipWithParticipationCloseToExit.map(
    ({ mainContentId }) => mainContentId,
  );
  const oppositionIds = [...oppositionIdsWithoutParticipation, ...oppositionIdsWithParticipationCloseToExit];
  const oppositions = await OppositionService.getOppositions({
    ids: oppositionIds,
    embeddedEntities: [OppositionAllowedEmbeddedEntities.MainCategory],
  });

  const championships = [...championshipWithoutParticipation, ...championshipWithParticipationCloseToExit];

  return championships.map(resource => {
    return {
      ...resource,
      opposition: oppositions.resources.find(opposition => opposition.id === resource.mainContentId),
    };
  });
};

export type ReturnGetParticipantChampionships = ReturnType<typeof getParticipantChampionships>;

export default getParticipantChampionships;
